(function () {
    'use strict';

    angular.module('gallery')
        .service('GalleryService', ['$http', 'GalleryConfigService', 'dialogService',
            function ($http, GalleryConfigService, dialogService) {
                var object = {};
                return {
                    getCurrentObject: function () {
                        return object;
                    },
                    setCurrentObject: function (obj) {
                        object = obj;
                    },
                    deleteImage: function (ID, success, error) {
                        $http.delete(GalleryConfigService.deleteImageURL + ID)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(success)) {
                                    success(data, status, headers, config);
                                }
                            }).
                            error(function (data, status, headers, config) {
                                if (angular.isDefined(error)) {
                                    error(data, status, headers, config);
                                }
                            }
                            );
                    },
                    getImages: function (OID, success, error) {
                        $http.get(GalleryConfigService.getImageListURL + OID).
                            success(function (data, status, headers, config) {
                                if (angular.isDefined(success)) {
                                    success(data, status, headers, config);
                                }
                            }).
                            error(function (data, status, headers, config) {
                                if (angular.isDefined(error)) {
                                    error(data, status, headers, config);
                                }
                            }
                            );
                    },
                    uploadImages: function (OID, inputElement, droppedFile, successCallback) {
                        if (typeof FormData === 'undefined')//IE fallback
                        {
                            var iframe = document.createElement('iframe');
                            iframe.setAttribute('id', 'IEupload');
                            iframe.setAttribute('name', 'IEupload');
                            iframe.setAttribute('width', '0');
                            iframe.setAttribute('height', '0');
                            iframe.setAttribute('border', '0');
                            iframe.setAttribute('src', 'javascript:false;');
                            iframe.style.display = 'none';

                            var form = document.createElement('form');
                            form.setAttribute('target', 'IEupload');
                            form.setAttribute('action', GalleryConfigService.postImageURL + OID);
                            form.setAttribute('method', 'post');
                            form.setAttribute('enctype', 'multipart/form-data');
                            form.setAttribute('encoding', 'multipart/form-data');
                            form.style.display = 'block';

                            form.appendChild(inputElement);

                            document.body.appendChild(form);
                            document.body.appendChild(iframe);
                            var iframeFile = document.getElementById('IEupload');

                            var uploadHandler = function () {
                                if (iframeFile.detachEvent)
                                    iframeFile.detachEvent('onload', uploadHandler);
                                else
                                    iframeFile.removeEventListener('load', uploadHandler, false);
                                form;
                                successCallback();
                            }

                            if (typeof successCallback !== 'undefined') {
                                if (iframeFile.addEventListener)
                                    iframeFile.addEventListener('load', uploadHandler, true);
                                else if (iframeFile.attachEvent)
                                    iframeFile.attachEvent('onload', uploadHandler);
                            }

                            form.submit();
                            return;
                        }

                        var fd = new FormData();
                        if (droppedFile === null) {
                            for (var i = 0; i < inputElement.files.length; i++) {
                                if (inputElement.files[i].type.indexOf('image') === -1) {
                                    dialogService.error('Negalima prisegti failo "' + inputElement.files[i].name + '": Nepalaikomas formatas.');
                                    continue;
                                }
                                fd.append('file', inputElement.files[i]);
                            }
                        } else {
                            fd.append('file', droppedFile);
                        }

                        $http.post(GalleryConfigService.postImageURL + OID, fd, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined }
                        })
                            .success(function () {
                                if (typeof successCallback !== 'undefined')
                                    successCallback();
                            })
                            .error(function () {
                                dialogService.error('Įvyko klaida pridedant nuotraukas prie duomenų bazės.');
                            });
                    }
                };
            }]);
})();
